const resourcePageIntroBlock = document.querySelectorAll(
    ".resource-page-intro"
);

resourcePageIntroBlock.forEach((block) => {
    const pageSelector = block.querySelector("select");
    if (pageSelector) {
        pageSelector.addEventListener("change", (event: Event) => {
            const target = event.target as HTMLSelectElement;
            const selectedValue = target.value;

            if (selectedValue) {
                window.location.href = selectedValue;
            }
        });
    }
});
